import { render, staticRenderFns } from "./ProductionForm.vue?vue&type=template&id=c4ddb1fa&scoped=true&"
import script from "./ProductionForm.vue?vue&type=script&lang=js&"
export * from "./ProductionForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductionForm.vue?vue&type=style&index=0&id=c4ddb1fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ddb1fa",
  null
  
)

export default component.exports